"use client";

import { H4 } from "@/components-shared/headers";
import PropCard from "@/components-shared/prop-card";
import PropCardSkeleton from "@/components-shared/prop-card-skeleton";

import { useAppSelector } from "@/redux/store";
import React, { useEffect } from "react";
import PropsPagination from "./props-pagination";

import { useSearchParams } from "next/navigation";
import { useGetProps } from "../utils/get-props-hook";

import Map from "./map";
import { useTranslations } from "next-intl";

const INITIAL_BOUNDS = {
  north: 28.501401668016406,
  south: 20.51334138073827,
  west: 37.294043359375,
  east: 52.872656640625,
};

const AllPropsMap = () => {
  const t = useTranslations();
  const searchParams = useSearchParams();
  const { isLoggedIn } = useAppSelector((state) => state.login);
  const [selectedProp, setSelectedProp] = React.useState<Property | null>(null);

  const [bounds, setBounds] =
    React.useState<google.maps.LatLngBoundsLiteral>(INITIAL_BOUNDS);

  const { data, refetch, setMapValues, error, isLoading } = useGetProps(
    4,
    bounds
  );

  const handleClickOnMarker = (prop: Property) => {
    setSelectedProp(prop);
  };

  useEffect(() => {
    refetch();
  }, [isLoggedIn, refetch]);

  return (
    <div className="flex max-sm:flex-col-reverse h-full relative gap-8">
      {error || (!data?.properties?.length && !isLoading) ? (
        <H4 className="text-center w-full my-20 text-gray-light">
          {t("allPropsMap.noData")}{" "}
        </H4>
      ) : (
        <>
          <>
            <div className="flex-1 grid grid-cols-[repeat(auto-fill,minmax(20rem,1fr))] gap-4 mb-8">
              {selectedProp && (
                <PropCard
                  id={selectedProp.id}
                  propData={selectedProp}
                  image={selectedProp?.media?.find((m) => m.isMain)?.url}
                />
              )}
              <H4 className="text-center col-span-full w-full border-t border-b">
                {t("allPropsMap.allProps")}
              </H4>
              {isLoading
                ? Array.from({ length: 4 }).map((_, i) => (
                    <PropCardSkeleton key={`card ${i}`} />
                  ))
                : data?.properties?.map((prop: Property) => (
                    <PropCard
                      key={prop.id}
                      id={prop.id}
                      propData={prop}
                      image={prop?.media?.find((m) => m.isMain)?.url}
                    />
                  ))}

              <PropsPagination
                pagesCount={data?.pagesCount}
                page={
                  "page" in searchParams
                    ? +(searchParams.get("page") || 1)
                    : data?.page
                }
              />
            </div>
          </>
        </>
      )}

      <Map
        {...{
          bounds,
          setBounds,
          setMapValues,
          handleClickOnMarker,
        }}
      />
    </div>
  );
};

export default AllPropsMap;
